import apiSlice from "state/api/apiSlice";

export const contractsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getContractsByMeterId: builder.query({
      query: ({ communityId, meterId }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts`,
        method: "GET",
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: "Contract", id: arg.meterId },
              ...result.map((c) => ({ type: "Contract", id: c.id })),
            ]
          : [{ type: "Contract", id: arg.meterId }],
    }),
    /* POST */
    addNewContract: builder.mutation({
      query: ({ communityId, meterId, contract }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts`,
        method: "POST",
        body: { ...contract },
      }),
      invalidatesTags: (_, __, arg) => [{ type: "Contract", id: arg.meterId }],
    }),
    cloneContract: builder.mutation({
      query: ({ communityId, contractId, meterId }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts/${contractId}/clone`,
        method: "POST",
      }),
      invalidatesTags: (_, __, arg) => [{ type: "Contract", id: arg.meterId }],
    }),
    /* PUT */
    updateContract: builder.mutation({
      query: ({ communityId, meterId, contractId, contract }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts/${contractId}`,
        method: "PUT",
        body: { ...contract },
      }),
      invalidatesTags: (_, __, arg) => [{ type: "Contract", id: arg.meterId }],
    }),
    /* DELETE */
    deleteContractById: builder.mutation({
      query: ({ communityId, meterId, contractId }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts/${contractId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, arg) => [{ type: "Contract", id: arg.meterId }],
    }),
  }),
});

export const {
  useGetContractsByMeterIdQuery,
  useAddNewContractMutation,
  useUpdateContractMutation,
  useDeleteContractByIdMutation,
  useCloneContractMutation,
} = contractsApiSlice;
